export default __webpack_public_path__ + "static/media/cosyfish-bg.b265c890.jpg";